module.exports = __webpack_public_path__ + "img/compass.90b04e13.svg";